module.exports = __webpack_public_path__ + "static/media/hanleyenergy.b85fc045.png";